import state from "./state";
import actions from "./actions";
import mutations from "./mutations";

const getters = {
  getFDStaffList: (state) => state.items,
  getFDStaffListPagination: (state) => state.pagination,
  getFDStaffListPage: (state) => state.pagination.current_page,
};
export default {
  state,
  actions,
  mutations,
  getters,
};
